import $ from "jquery";

const sliderPortfolio = () => {
  const el = {
    // target: ".js-slider-portfolio",
    target: ".js-slider-portfolio",
  };

  let $target = $();

  const defineVar = () => {
    $target = $(el.target);
  };

  const init = () => {
    $(document).ready(function () {
      defineVar();
      if ($target.length) {
        exec();
      }
    });
  };

  const exec = () => {
    $target
      .slick({
        infinite: true,
        centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: false,
        adaptiveHeight: true,
        speed: 600,
        useCSS: true,
        // cssEase: "cubic-bezier(0.4, 0, 0.2, 1)",
        // centerPadding: "64px",
        autoplay: true,
        autoplaySpeed: 4200,
        waitForAnimate: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              centerMode: true,
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: false,
              speed: 400,
              autoplaySpeed: 3100,
            },
          },
        ],
      })

      // eslint-disable-next-line no-unused-vars
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        setTimeout(() => {
          if (window.outerWidth > 1024)
            slick.$list.css({
              marginLeft: 64 * (nextSlide !== 0 ? nextSlide : 0),
            });

          if (window.outerWidth >= 896 && window.outerWidth <= 1024)
            slick.$list.css({
              marginLeft: 40 * (nextSlide !== 0 ? nextSlide : nextSlide + 1),
            });

          if (window.outerWidth < 896)
            slick.$list.css({
              marginLeft:
                -23 * (nextSlide !== 0 ? nextSlide : nextSlide + 0.5) +
                Math.max(window.outerWidth - 800, 0),
            });

          if (window.outerWidth < 601)
            slick.$list.css({
              marginLeft: -52 * (nextSlide !== 0 ? nextSlide : nextSlide + 1),
            });
        }, 1);
      });

    // $target.find(".project-homepage__image").clone().appendTo($target);

    // $target.on("init reInit", function (event, slick) {
    //   slick.$slides.eq(0).css({
    //     width: window.outerWidth > 600 ? "383px" : "300px",
    //     height: window.outerWidth > 600 ? "410px" : "320px",
    //   });

    //   slick.$slides
    //     .eq(0)
    //     .find("img")
    //     .css({
    //       width: window.outerWidth > 600 ? "383px" : "300px",
    //       height: window.outerWidth > 600 ? "410px" : "320px",
    //     });

    //   setTimeout(() => {
    //     slick.$slides
    //       .find("img")
    //       .css(
    //         "transition",
    //         "height 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
    //       );
    //     $target.slick("setPosition");
    //   }, 0);
    // });
    // // eslint-disable-next-line no-unused-vars
    // .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    //   let idx = slick.$slides.index(
    //     slick.$slides.filter(".slick-current").next()
    //   );

    //   console.log({
    //     idx,
    //     slides: slick.$slides,
    //     direction: nextSlide,
    //   });

    //   if (window.outerWidth > 1024) {
    //     slick.$slideTrack.css({ marginLeft: 32 * idx }, 200);
    //   } else if (window.outerWidth > 600) {
    //     slick.$slideTrack.css({ marginLeft: 40 * (idx + 1) }, 200);
    //   } else {
    //     slick.$slideTrack.css(
    //       { marginLeft: 0.021 * window.innerWidth * (idx + 1) },
    //       200
    //     );
    //   }
    //   // Force a browser reflow
    //   void document.documentElement.offsetHeight;

    //   setTimeout(() => {
    //     $(".slick-slide").css({
    //       width: window.outerWidth > 600 ? "256px" : "200px",
    //       height: window.outerWidth > 600 ? "274px" : "214px",
    //     });

    //     $(".slick-slide img").css({
    //       width: window.outerWidth > 600 ? "256px" : "200px",
    //       height: window.outerWidth > 600 ? "274px" : "214px",
    //     });

    //     $(".slick-slide.slick-current").css(
    //       {
    //         width: window.outerWidth > 600 ? "383px" : "300px",
    //         height: window.outerWidth > 600 ? "410px" : "320px",
    //       },
    //       200
    //     );

    //     $(".slick-slide.slick-current")
    //       .find("img")
    //       .css(
    //         {
    //           width: window.outerWidth > 600 ? "383px" : "300px",
    //           height: window.outerWidth > 600 ? "410px" : "320px",
    //         },
    //         200
    //       );
    //   }, 32);
    //   // Re-enable transitions
    //   $target.slick("setPosition");
    // });
  };

  init();
};

try {
  sliderPortfolio();
} catch (error) {
  console.error(error);
}
